// extracted by css-extract-rspack-plugin
export default {"container":"_5af83b6d","rating":"_c4e3e7cd","small":"_73fa11b5","medium":"_bbe19a17","noReviews":"_78336862"};